import { blockquote } from './blockquote.js';
import { hardBreak } from './break.js';
import { code } from './code.js';
import { definition } from './definition.js';
import { emphasis } from './emphasis.js';
import { heading } from './heading.js';
import { html } from './html.js';
import { image } from './image.js';
import { imageReference } from './image-reference.js';
import { inlineCode } from './inline-code.js';
import { link } from './link.js';
import { linkReference } from './link-reference.js';
import { list } from './list.js';
import { listItem } from './list-item.js';
import { paragraph } from './paragraph.js';
import { root } from './root.js';
import { strong } from './strong.js';
import { text } from './text.js';
import { thematicBreak } from './thematic-break.js';

/**
 * Default (CommonMark) handlers.
 */
export var handle = {
  blockquote: blockquote,
  break: hardBreak,
  code: code,
  definition: definition,
  emphasis: emphasis,
  hardBreak: hardBreak,
  heading: heading,
  html: html,
  image: image,
  imageReference: imageReference,
  inlineCode: inlineCode,
  link: link,
  linkReference: linkReference,
  list: list,
  listItem: listItem,
  paragraph: paragraph,
  root: root,
  strong: strong,
  text: text,
  thematicBreak: thematicBreak
};